// extracted by mini-css-extract-plugin
export default {"citeTooltip":"CiteRef__citeTooltip___gZYM8"};